import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['httpFields', 'stdioFields']

  switchTransport(event) {
    this.#toggle(this.httpFieldsTarget, event.target.value !== 'http')
    this.#toggle(this.stdioFieldsTarget, event.target.value !== 'stdio')
  }

  #toggle(group, hidden) {
    group.hidden = hidden
    group.querySelectorAll('input, textarea, select').forEach((field) => {
      field.disabled = hidden
    })
  }
}
